// extracted by mini-css-extract-plugin
export default {"tasks":"DM-z","task":"EM-z","svg":"FM-z","text":"GM-z"};